import React from "react";

import ServiceSection from "../components/ServiceSection";
import OfficeLocationsCentersSection from "../components/OfficeLocationsCentersSection";

const ServicesPage = ({title, whatsappnumber, path}) => {
  return (
    <>
      <ServiceSection title={title} whatsappnumber={whatsappnumber} path={path} />
      <OfficeLocationsCentersSection  />
    </>
  );
};

export default ServicesPage;
